import React from "react";
import LegalPage from "./LegalPage";

const Cookies = () => <LegalPage tKey="pages.cookies" testId="cookies-page" />;
export default Cookies;
